module.exports = __webpack_public_path__ + "img/brasao.5f71ca59.png";